export const WeaningStatus = {
  PRE_WEANING: 'pre_weaning',
  POST_WEANING: 'post_weaning',
};

export const LactationCharacterization = {
  FRESH: 'fresh',
  PRIMIPAROUS: 'primiparous',
  PLURIPARE: 'pluripare',
  TIRED: 'tired',
  UNIQUE_GROUP: 'unique_group',
};
